import React, { useState } from 'react';
import { toast } from 'sonner';
import { Mail, Loader2, Send } from 'lucide-react';
import { apiClient } from '../../App';
import { Button } from '../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';

export const WeeklyEmailPreview = () => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [sending, setSending] = useState(false);

  const openPreview = async () => {
    setOpen(true);
    setData(null);
    try {
      const res = await apiClient.get('/admin/weekly-engagement/preview');
      setData(res.data);
    } catch (err) {
      toast.error('Could not load the weekly email preview');
      setOpen(false);
    }
  };

  const sendCopy = async () => {
    setSending(true);
    try {
      const res = await apiClient.post('/admin/weekly-engagement/send-test', {}, { timeout: 30000 });
      toast.success(`Copy sent to ${res.data.sent_to}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Email could not be sent');
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <Button
        variant="outline"
        onClick={openPreview}
        className="border-stone-300 text-stone-800 hover:border-[#EFB342] rounded-full"
        data-testid="weekly-email-preview-btn"
      >
        <Mail size={16} className="mr-2" /> Weekly email
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white border-stone-200 max-w-3xl" data-testid="weekly-email-dialog">
          <DialogHeader>
            <DialogTitle>Weekly engagement email</DialogTitle>
            <p className="text-sm text-stone-600 pt-1" data-testid="weekly-email-recipient">
              Arrives every Monday at 7am (Vancouver time){data ? ` at ${data.recipient}` : ''}, covering last Monday to Sunday.
            </p>
          </DialogHeader>
          {!data ? (
            <div className="flex items-center justify-center py-20 text-stone-500"><Loader2 className="animate-spin mr-2" size={18} /> Building preview…</div>
          ) : (
            <iframe title="Weekly email preview" srcDoc={data.html} className="w-full h-[60vh] rounded-lg border border-stone-200" data-testid="weekly-email-iframe" />
          )}
          <div className="flex justify-end">
            <Button
              onClick={sendCopy}
              disabled={!data || sending}
              className="bg-[#EFB342] text-black hover:bg-[#D99F30] rounded-full"
              data-testid="weekly-email-send-copy-btn"
            >
              {sending ? <Loader2 size={16} className="animate-spin mr-2" /> : <Send size={16} className="mr-2" />}
              Email me a copy now
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
